import React from 'react';
import styled from 'styled-components';
import { useTranslation } from '../context/LanguageContext';
import { 
  House, 
  Book, 
  Brain,
  Calendar,
  Lightning,
  ArrowRight 
} from "@phosphor-icons/react";
import { motion } from 'framer-motion';

const PageContainer = styled.div`
  background: #0d1117;
  color: white;
`;

const HeroSection = styled.section`
  min-height: 90vh;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  max-width: 1400px;
  margin: 0 auto;
  padding: 8rem 2rem;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    padding: 6rem 1rem;
  }
`;

const HeroContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  h1 {
    font-size: 4rem;
    font-weight: 800;
    line-height: 1.1;
    margin-bottom: 1.5rem;
    background: linear-gradient(90deg, #fff, #b3b3b3);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  p {
    font-size: 1.25rem;
    color: #8b949e;
    margin-bottom: 2rem;
    line-height: 1.6;
  }
`;

const CTAButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: #3AB7FF;
  color: white;
  padding: 1rem 2rem;
  border-radius: 8px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s;
  width: fit-content;

  &:hover {
    transform: translateY(-2px);
    background: #50c1ff;
  }
`;

const HomeschoolPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <PageContainer>
      <HeroSection>
        <HeroContent>
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            Empower Your Homeschool Journey
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.5 }}
          >
            Create a personalized learning environment with curriculum planning, 
            progress tracking, and comprehensive educational resources.
          </motion.p>
          
          <CTAButton 
            href="https://forms.gle/4QSAYKM7i4UAaep18"
            target="_blank"
            rel="noopener noreferrer"
          >
            Join the Waitlist <ArrowRight weight="bold" />
          </CTAButton>
        </HeroContent>
      </HeroSection>
    </PageContainer>
  );
};

export default HomeschoolPage; 